import { call, put, takeLatest } from 'redux-saga/effects';

import * as instagramActions from './instagramActions.js';
import { updateInstagramApiCall } from './instagramAPI.js';

function* updateInstagramSaga({ payload }) {
  try {
    const { data } = yield call(updateInstagramApiCall, payload);
    yield put(instagramActions.instagramUpdateStore(data));
  } catch (error) {
    yield put(instagramActions.instagramUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* instagramWatcher() {
  yield takeLatest(instagramActions.instagramUpdateRequest.type, updateInstagramSaga);
}
